var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"home-btn",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("assets/svg/compiled/blue-chat-bubble.svg"),"width":"28px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }